import update from 'immutability-helper'
import { memo, useCallback, useState, useEffect } from 'react'
import { useDrop } from 'react-dnd'
import { Card } from './Card.js'
import { ItemTypes } from '../ItemTypes.js'
const style = {
  width: "50%",
}



const Container = memo(function Container(props) {
  const { subTwoItems, exportNewSubTwo } = props
  const [cards, setCards] = useState([])
  const [deleteId, setDeleteId] = useState({ cardId: "umlang", cardIndex: null })
  const [newCardId, setNewCardId] = useState(0)


  const handleAlertDeleteCard = (cardId, cardIndex) => {
    setDeleteId({ cardId, cardIndex })
  }
  const findCard = useCallback(
    (id) => {
      const card = cards.filter((c) => `${c.id}` === id)[0]
      return {
        card,
        index: cards.indexOf(card),
      }
    },
    [cards],
  )
  const moveCard = useCallback(
    (id, atIndex) => {
      const { card, index } = findCard(id)
      setCards(
        update(cards, {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        }),
      )
    },
    [findCard, cards, setCards],
  )
  const [, drop] = useDrop(() => ({ accept: ItemTypes.CARD }))

  const insertNewCard = (index) => {
    const cpCards = [...cards]
    cpCards.splice(index, 0, { id: newCardId, text: 'www.umlang.com \n یادگیری زبان با فیلم و سریال (دو زیرنویس همزمان)' });
    setCards(cpCards)
    setNewCardId(newCardId + 1)
  }

  const deleteCard = () => {
    const cpCards = [...cards]
    cpCards.splice(deleteId["cardIndex"], 1);
    setCards(cpCards)
    handleAlertDeleteCard("umlang", null)
  }

  const changeCardText = (index, text) => {
    const cpCards = [...cards]
    cpCards[index]["text"] = text
    setCards(cpCards)
  }

  const pasteTop = (index, text) => {
    const cpCards = [...cards]
    cpCards[index]["text"] = `${text} \n${cpCards[index]["text"]}`
    setCards(cpCards)
  }
  const pasteDown = (index, text) => {
    const cpCards = [...cards]
    cpCards[index]["text"] = `${cpCards[index]["text"]} \n${text}`
    setCards(cpCards)
  }
  const replaceText = (index, text) => {
    const cpCards = [...cards]
    cpCards[index]["text"] = `${text}`
    setCards(cpCards)
  }


  useEffect(() => {
    if (subTwoItems) {
      setCards(subTwoItems)
      setNewCardId(subTwoItems.length + 1)
    }
  }, [subTwoItems])

  // useEffect(() => {
  //   if (cards.length == 0) setCards(subTwoItems)
  // })
  return (
    <div ref={drop} style={style}>
      {deleteId["cardId"] == "umlang" ? null :
        <div style={{ position: "fixed", width: "250px", height: "100px", top: "20px", right: "30%", backgroundColor: "red", borderRadius: "11px", padding: "10px" }}>
          آیا از حذف زیرنویس {deleteId["cardId"]} مطمئن هستید؟
          <br />
          <br />
          <button style={{ margin: "10px" }} onClick={deleteCard}>بله</button>
          <button style={{ margin: "10px" }} onClick={() => { handleAlertDeleteCard("umlang", null) }} >خیر</button>
        </div>
      }

      {cards.map((card, cardIndex) => (
        <div style={{ height: "50px" }} key={`sub-${cardIndex}`}>
          <Card
            key={card.id}
            id={`${card.id}`}
            text={card.text}
            startSeconds={card.startSeconds}
            endSeconds={card.endSeconds}
            moveCard={moveCard}
            findCard={findCard}
            cardIndex={cardIndex}
            insertNewCard={insertNewCard}
            handleAlertDeleteCard={handleAlertDeleteCard}
            changeCardText={changeCardText}
            pasteTop={pasteTop}
            pasteDown={pasteDown}
            replaceText={replaceText}
          />
        </div>

      ))}
      {cards.length > 0 ? <button onClick={() => { exportNewSubTwo(cards) }} style={{ marginRight: "43%" }} >دریافت زیرنویس دوم</button> : null}
    </div>
  )
})


export default Container
